var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClimateChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.22,62.55s-.93,4.79-5.14,6.74c-1.64.76-.22,5.12-3.75,3.77s-.61-2.58-4.17-6.23-1.54-5.39-1.86-6.95M70.45,70.14s0,2.18-.23,6.4c-.27,4.69,2.25,10.33,9.85,11.7,5.18.92,4,11.49,4,11.49s-6.14,3.88-6.95,10.62,11.68,13,11.68,13,5.49,3.43,3.45,9.46c0,0,.44,14.07,4.89,14.49S95.75,141,103,135.7c0,0,4.1-4.66,3.43-8.21a14.61,14.61,0,0,1-.06-5.8s15.22-13-7-18.34c-12.66-3-5.94-11.7-2.54-12.54,11.33-2.79,8.5,6.16,10.87,6.07,10.15-.39-.11-6.28,7.77-10.26,6-3.05,2.32-12.33,5.56-13.73,0,0,5.68-2.8,3.1-6.89M131,152c-7.82,6.51-19.29,10.66-30.5,10.66a51.63,51.63,0,1,1,0-103.25c25,0,47,17.44,50.92,44.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.65,131.06a7.49,7.49,0,0,0,1.74-4.73c0-4.85-4.92-8.77-11-8.77a13.28,13.28,0,0,0-3.31.41c-3.46-7.24-9.62-12.06-16.64-12.06-9.27,0-17,8.37-19.06,19.61q-.79-.06-1.59-.06c-8.8,0-15.93,5.7-15.93,12.73s7.13,12.72,15.93,12.72a19.19,19.19,0,0,0,7-1.28c3.53,4.49,8.36,7.26,13.69,7.26,6.08,0,11.52-3.62,15.11-9.28a50,50,0,0,0,7.11.51c11.68,0,21.15-3.94,21.15-8.78C199.82,135.51,193.9,132.26,185.65,131.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.37,116.93l-7.91-7.41L25.92,118m124.27,39.57a67.87,67.87,0,0,1-118.27-45.7M155.86,84.52l9.92,4.39,2.43-9.84M37.83,82.73a67.89,67.89,0,0,1,126.74,4.11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimateChange);
export default __webpack_public_path__ + "static/media/CLIMATE_CHANGE.1c4c4c1b28dadfbf88453ce28f06b342.svg";
export { ForwardRef as ReactComponent };